import { firstToUppercase } from "./utils";

export const pollutantMetricPopup = (feature) => {
  const { query_layer, query_year } =
    feature.graphic.layer.customPopupAttributes;
  const getQueryLayer =
    firstToUppercase(query_layer) === "La"
      ? "Local Authority"
      : firstToUppercase(query_layer);
  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold">${feature.graphic.attributes.name}</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.compliance_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Maximum Value</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.maximum_value}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Year</th>
        <td class="esri-feature-fields__field-data">${query_year}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">${getQueryLayer} Code</th>
        <td class="esri-feature-fields__field-data">${feature.graphic.attributes.unique_code}</td>
      </tr>
    <tbody/>
  </table>
  `;

  return popupTable;
};

export const popupForRoad = (feature, type, pollutant_metric) => {
  const {
    zone_name,
    la_name,
    zone_unique_code,
    la_unique_code,
    census_id,
    road_length_km,
    road_number,
    value,
    unit,
    dft_count_point_id,
    compliance_status,
    compliance_metric,
  } = feature.graphic.attributes;
  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold">${
          type === "zone" ? zone_name : la_name
        }</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${compliance_metric}</td>
      </tr>
      <tr>
      	<th class="esri-feature-fields__field-header">Value</th>
      	<td class="esri-feature-fields__field-data">${value}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Road Length (km)</th>
        <td class="esri-feature-fields__field-data">${road_length_km}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Road Number</th>
        <td class="esri-feature-fields__field-data">${road_number}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">DfT Count Point ID</th>
        <td class="esri-feature-fields__field-data">${dft_count_point_id}</td>
      </tr>      
     <tr>
        <th class="esri-feature-fields__field-header">Censud ID</th>
        <td class="esri-feature-fields__field-data">${census_id}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unique Code</th>
        <td class="esri-feature-fields__field-data">${
          type === "zone" ? zone_unique_code : la_unique_code
        }</td>
      </tr>
    <tbody/>
  </table>
  `;

  return popupTable;
};

export const popupForRoadComp = (feature, type, pollutant_metric) => {
  const {
    zone_name,
    la_name,
    zone_unique_code,
    la_unique_code,
    census_id,
    road_length_km,
    road_number,
    value,
    unit,
    dft_count_point_id,
    value_source,
    compliance_status,
    compliance_metric
  } = feature.graphic.attributes;
  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold">${
          type === "zone" ? zone_name : la_name
        }</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${compliance_metric}</td>
      </tr>
      <tr>
      	<th class="esri-feature-fields__field-header">Value</th>
      	<td class="esri-feature-fields__field-data">${value}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Value Source</th>
        <td class="esri-feature-fields__field-data">${value_source}</td>
      </tr>
            <tr>
        <th class="esri-feature-fields__field-header">Road Number</th>
        <td class="esri-feature-fields__field-data">${road_number}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Road Length (km)</th>
        <td class="esri-feature-fields__field-data">${road_length_km}</td>
      </tr>
     <tr>
        <th class="esri-feature-fields__field-header">DfT Count Point ID</th>
        <td class="esri-feature-fields__field-data">${dft_count_point_id}</td>
      </tr>
     <tr>
        <th class="esri-feature-fields__field-header">Censud ID</th>
        <td class="esri-feature-fields__field-data">${census_id}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unique Code</th>
        <td class="esri-feature-fields__field-data">${type === "zone" ? zone_unique_code : la_unique_code}</td>
      </tr>
    <tbody/>
  </table>
  `;

  return popupTable;
};

export const popupForPoints = (feature, type, pollutant_metric) => {
  const {
    zone_name,
    la_name,
    zone_unique_code,
    la_unique_code,
    easting,
    northing,
    eoi_code,
    site_code,
    site_name,
    site_type,
    value,
    aggregating_period,
    data_capture_percent,
    unit,
    url,
    compliance_status,
    compliance_metric,
  } = feature.graphic.attributes;

  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold"><span class="font-bold">${
          type === "zone" ? zone_name : la_name
        }</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Site Name</th>
        <td class="esri-feature-fields__field-data">${site_name}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${compliance_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Value</th>
        <td class="esri-feature-fields__field-data">${value}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Aggregating Period</th>
        <td class="esri-feature-fields__field-data">${aggregating_period}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Data Capture (%)</th>
        <td class="esri-feature-fields__field-data">${data_capture_percent}</td>
      </tr> 
      <tr>
        <th class="esri-feature-fields__field-header">Site Type</th>
        <td class="esri-feature-fields__field-data">${site_type}</td>
      </tr>
        ${
          url
              ? `<tr>
            <th class="esri-feature-fields__field-header">Site Info</th>
            <td class="esri-feature-fields__field-data"><a href="${url}" target="_blank">Site link</a></td>
          </tr>`
              : ``
        }
      <tr>
        <th class="esri-feature-fields__field-header">Easting</th>
        <td class="esri-feature-fields__field-data">${easting}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Northing</th>
        <td class="esri-feature-fields__field-data">${northing}</td>
      </tr> 
      <tr>
        <th class="esri-feature-fields__field-header">Unique Code</th>
        <td class="esri-feature-fields__field-data">${
          type === "zone" ? zone_unique_code : la_unique_code
        }</td>
      </tr>
     <tr>
        <th class="esri-feature-fields__field-header">EOI Code</th>
        <td class="esri-feature-fields__field-data">${eoi_code}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Site Code</th>
        <td class="esri-feature-fields__field-data">${site_code}</td>
      </tr>
    <tbody/>
  </table>
  `;

  return popupTable;
};

export const popupForPolygon = (feature, type, pollutant_metric) => {
  const {
    zone_name,
    la_name,
    zone_unique_code,
    la_unique_code,
    easting,
    northing,
    value,
    unit,
    compliance_metric,
    compliance_status,
  } = feature.graphic.attributes;
  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold">${
          type === "zone" ? zone_name : la_name
        }</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${compliance_metric}</td>
      </tr> 
      <tr>
        <th class="esri-feature-fields__field-header">Value</th>
        <td class="esri-feature-fields__field-data">${value}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Easting</th>
        <td class="esri-feature-fields__field-data">${easting}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Northing</th>
        <td class="esri-feature-fields__field-data">${northing}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unique Code</th>
        <td class="esri-feature-fields__field-data">${type === "zone" ? zone_unique_code : la_unique_code}</td>
      </tr>
    <tbody/>
    <tbody/>
  </table>
  `;

  return popupTable;
};

export const popupForPolygonComp = (feature, type, pollutant_metric) => {
  const {
    zone_name,
    la_name,
    zone_unique_code,
    la_unique_code,
    easting,
    northing,
    value,
    unit,
    value_source,
    compliance_metric,
    compliance_status
  } = feature.graphic.attributes;
  const popupTable = `
  <table class="esri-widget__table mb-3">
    <tbody>
      <tr>
        <th class="esri-feature-fields__field-header"><span class="font-bold">Name</span></th>
        <td class="esri-feature-fields__field-data"><span class="font-bold">${
          type === "zone" ? zone_name : la_name
        }</span></td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Pollutant Metric</th>
        <td class="esri-feature-fields__field-data">${pollutant_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Status</th>
        <td class="esri-feature-fields__field-data">${compliance_status}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Compliance Metric</th>
        <td class="esri-feature-fields__field-data">${compliance_metric}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Value</th>
        <td class="esri-feature-fields__field-data">${value}</td>
      </tr> 
      <tr>
        <th class="esri-feature-fields__field-header">Unit of Measure</th>
        <td class="esri-feature-fields__field-data">${unit}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Value Source</th>
        <td class="esri-feature-fields__field-data">${value_source}</td>
      </tr>

      <tr>
        <th class="esri-feature-fields__field-header">Easting</th>
        <td class="esri-feature-fields__field-data">${easting}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Northing</th>
        <td class="esri-feature-fields__field-data">${northing}</td>
      </tr>
      <tr>
        <th class="esri-feature-fields__field-header">Unique Code</th>
        <td class="esri-feature-fields__field-data">${type === "zone" ? zone_unique_code : la_unique_code}</td>
      </tr>
    <tbody/>
  </table>
  `;

  return popupTable;
};
